// Lib
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

// Theme
import colors from 'theme/colors';

const Item = styled(Link)<any>`
  cursor: default;
  color: ${colors.primary};
  font-size: 17px;
  text-decoration: none;
  margin-bottom: 10px;

  :last-child {
    margin-bottom: 0;
  }

  ${props =>
    props.to.length && {
      color: colors.turquoise,
      textDecoration: 'underline',
      cursor: 'pointer',
    }}
`;

const Dot = styled.div`
  width: 10px;
  height: 10px;
  margin-right: 10px;
  border-radius: 50%;
  border: 1px solid black;
  display: inline-block;
`;

interface DashBoardStatisticItemProps {
  children: any;
  to?: string | object;
}

const DashBoardStatisticItem: React.FC<DashBoardStatisticItemProps> = (props): JSX.Element => {
  const { children, to } = props;

  return (
    <Item to={to}>
      <Dot /> {children}
    </Item>
  );
};

DashBoardStatisticItem.defaultProps = {
  to: {},
};

export default DashBoardStatisticItem;
